module.exports = __webpack_public_path__ + "static/media/before_n_after_a.bced3561.jpg";